import { Container, Divider, Stack } from "@mui/material";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import GeneralPageHeader from "../../common/GeneralPageHeader";
import RegionalFormatSection from "./RegionalFormatSection";
import UserProfileSection from "./UserProfileSection";

const AccountSettingsPage = () => {
  usePageTitle("Account Settings");

  return (
    <>
      <GeneralPageHeader title="Account Settings" />
      <Container maxWidth="md" disableGutters sx={{ py: 2.5 }}>
        <Stack spacing={4}>
          <UserProfileSection />
          <Divider flexItem />
          <RegionalFormatSection />
        </Stack>
      </Container>
    </>
  );
};

export default AccountSettingsPage;
